/* Home: Instagram marquee.

   The section renders a flat list of tiles; this script deals them
   round-robin into vertical tracks (`data-columns` on desktop, 2 on mobile)
   and duplicates each track
   once so the looping translateY animation has no visible seam.

   The original tiles are cached on first run so the marquee can be rebuilt
   from scratch whenever the theme editor re-renders the section or the
   merchant changes the column count — the previous version wiped the source
   markup and latched itself, so editor edits never took effect. */
const homeInstagramSources = new WeakMap();
const homeInstagramDesktop = window.matchMedia('(min-width: 990px)');

function readHomeInstagramSource(marquee) {
  if (!homeInstagramSources.has(marquee)) {
    homeInstagramSources.set(
      marquee,
      Array.from(marquee.children).map((item) => item.cloneNode(true))
    );
  }
  return homeInstagramSources.get(marquee);
}

function cloneHomeInstagramTile(item) {
  const clone = item.cloneNode(true);
  // Duplicates must not claim the same editor block id as the original, and
  // must stay out of the tab order and the accessibility tree.
  clone.removeAttribute('data-shopify-editor-block');
  clone.setAttribute('aria-hidden', 'true');
  clone.setAttribute('tabindex', '-1');
  return clone;
}

function buildHomeInstagramMarquee(root) {
  (root || document).querySelectorAll('[data-instagram-marquee]').forEach((marquee) => {
    const source = readHomeInstagramSource(marquee);
    if (!source.length) return;

    // Mobile always shows two half-width columns; desktop uses the setting.
    const columnCount = homeInstagramDesktop.matches ? parseInt(marquee.dataset.columns, 10) || 4 : 2;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const columns = Array.from({ length: columnCount }, () => []);
    source.forEach((item, index) => columns[index % columnCount].push(item.cloneNode(true)));

    const fragment = document.createDocumentFragment();

    columns.forEach((columnItems, columnIndex) => {
      if (!columnItems.length) return;

      const column = document.createElement('div');
      column.className = 'home-instagram__column';

      const track = document.createElement('div');
      track.className = 'home-instagram__track';

      if (!prefersReducedMotion) {
        track.classList.add(columnIndex % 2 === 0 ? 'home-instagram__track--up' : 'home-instagram__track--down');
      }

      columnItems.forEach((item) => track.appendChild(item));
      columnItems.forEach((item) => track.appendChild(cloneHomeInstagramTile(item)));

      column.appendChild(track);
      fragment.appendChild(column);
    });

    marquee.replaceChildren(fragment);
  });
}

buildHomeInstagramMarquee(document);
document.addEventListener('shopify:section:load', (event) => buildHomeInstagramMarquee(event.target));

// Rebuild when the OS motion preference changes, so the animation can be
// switched off (or back on) without a reload.
window
  .matchMedia('(prefers-reduced-motion: reduce)')
  .addEventListener('change', () => buildHomeInstagramMarquee(document));

// Re-deal the tiles when crossing the mobile/desktop breakpoint.
homeInstagramDesktop.addEventListener('change', () => buildHomeInstagramMarquee(document));
